/* eslint-disable max-len */
/**
 * Transforms podcast data from API response format to format expected by PodcastDetailsSlider
 * @param podcastData - Raw podcast data from API
 * @returns Transformed data for PodcastDetailsSlider
 */
export const transformPodcastDataForSlider = (podcastData: any) =>
{
	if (!podcastData)
	{
		return null;
	}

	return {
		// Core identification
		id  : podcastData._id,
		_id : podcastData._id,

		// Basic details
		title       : podcastData.title,
		description : podcastData.description,

		// Fix sourceType casing - convert to lowercase for consistency
		sourceType : podcastData.sourceType?.toLowerCase() || podcastData.sourceType,

		// Cover image - handle both object and URL formats
		coverImage : podcastData.coverImage
			? {
				url : typeof podcastData.coverImage === 'string'
					? podcastData.coverImage
					: podcastData.coverImage.url,
				canEdit : podcastData.coverImage.canEdit !== undefined
					? podcastData.coverImage.canEdit
					: true,
				canDelete : podcastData.coverImage.canDelete !== undefined
					? podcastData.coverImage.canDelete
					: false
			}
			: undefined,

		// Categories and tags
		categoryIds : podcastData.categoryIds || [],
		tags        : podcastData.tags || [],

		// Access control - fix visibility casing
		visibility    : podcastData.visibility?.toLowerCase() || podcastData.visibility,
		allowDownload : podcastData.allowDownload,
		allowShare    : podcastData.allowShare,
		accessControl : podcastData.accessControl,

		// Status and publishing - fix field name and casing
		status      : podcastData.podcastStatus?.toLowerCase() || podcastData.status?.toLowerCase(),
		publishDate : podcastData.scheduledPublishDate,

		// Podcast-specific fields
		seasons  : podcastData.seasons || [],
		episodes : podcastData.episodes || [],

		// Metadata - fix date field mapping
		companyId            : podcastData.companyId,
		createdBy            : podcastData.createdBy,
		updatedBy            : podcastData.updatedBy,
		createdAt            : podcastData.podcastCreatedAt || podcastData.createdAt,
		updatedAt            : podcastData.podcastUpdatedAt || podcastData.updatedAt,
		publishedAt          : podcastData.publishedAt,
		scheduledPublishDate : podcastData.scheduledPublishDate
	};
};